

import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from "@angular/forms";
import * as moment from 'moment'
import { ChecklistModel } from "../../shared/model/checklist.model";
import { EmailModel } from "../../shared/model/email.model";
import { SchedulingConfigService } from "../../shared/service/scheduling-config.service";
/*
 *  @author Davi Wegner
 *  @email davi@easypro.com.br
 *  @data 01/03/2021
**/
export interface formBaseModel {
    id: number,
    repeat_time: object[],
    repeat: boolean,
    days_in_week: object[],
    days_in_month: object[],
    from: string,
    to: string,
    active: boolean,
    checklist_id?: number | number[],
    action_plan_id?: number,
    title: string,
    type: 'action_plan' | 'checklist',
    editable: boolean,
    until: string,
    sender_id: number,
    responsible_id: number,
    date: string,
    hour: any,
    hours_before: number,
    hours_after: number
}
let date = new Date()
date.setHours(0, 0, 0)
const formBaseModel: formBaseModel = {
    id: null,
    repeat_time: [
        { value: 0, label: 'Todos os Dias' }, 
        { value: 1, label: 'Semanal' }, 
        { value: 2, label: 'Mensal' }
    ],
    // { value: 3, label: 'Anual' }
    repeat: false,
    days_in_week: [
        { "value": 0, "label": "Dom" }, 
        { "value": 1, "label": "Seg" }, 
        { "value": 2, "label": "Ter" }, 
        { "value": 3, "label": "Qua" }, 
        { "value": 4, "label": "Qui" }, 
        { "value": 5, "label": "Sex" }, 
        { "value": 6, "label": "Sab" }
    ],
    days_in_month: [],
    from: null,
    to: null,
    active: null,
    checklist_id: null,
    title: null,
    type: null,
    editable: null,
    until: null,
    sender_id: null,
    responsible_id: null,
    date: null,
    hour: date,
    hours_before: 0,
    hours_after: 0
}

@Component({
    selector: 'scheduling-form'
    , templateUrl: 'scheduling-form.component.html'
    , styleUrls: ['./scheduling-form.component.css']
})
export class SchedulingForm implements OnInit {
    form: formBaseModel = formBaseModel
    @Input() selectedDate: string
    @Input() emails: EmailModel[]
    @Input() checklists: ChecklistModel[]
    @Input() currentUserEmail: EmailModel
    @Input() responsibleNames: any
    @Input() checklistNames: any
    @Output() saveSchedules = new EventEmitter();
    @ViewChild('f', { read: NgForm }) formTag: any
    constructor(
        private schedulingConfigService: SchedulingConfigService,
        private translateService: TranslateService
        ) { }

    newForm: {
        [x: string]: any
    } = {
            repeat: false
        }
    saving: boolean = false
    invalid: boolean = false
    success: boolean = false
    error: boolean = false
    ngOnInit() {
        this.form.days_in_month = Array(moment().daysInMonth()).fill(0).map((item, i) => ({ value: i + 1, label: i + 1 }))
    }

    translate = (key: string) => this.translateService.instant(key || "invalid"); 
    
    setNewForm() {
        this.newForm = {
            repeat: false
        }
        this.form = formBaseModel
    }
    onSubmit(f) {
        if (this.newForm.sender_id !== 0 && !this.newForm.sender_id)
            this.newForm.sender_id = this.currentUserEmail.id
        // console.log(this.newForm)

        if (!this.newForm.responsible_id || this.newForm.responsible_id.length < 1) {
            this.invalid = true
            setTimeout(() => {
                this.invalid = false
            }, 5000)
            return
        }
        if (!this.newForm.checklist_id || this.newForm.checklist_id.length < 1) {
            this.invalid = true
            setTimeout(() => {
                this.invalid = false
            }, 5000)
            return
        }
        this.saving = true
        this.schedulingConfigService.post({ form: this.newForm, responsibleLabels: this.responsibleNames, checklistLabels: this.checklistNames }).subscribe(res => {
            this.saving = false
            this.invalid = false
            this.success = true
            setTimeout(() => {
                this.success = false
            }, 5000)
            this.formTag.reset()
            this.saveSchedules.emit()
        }, () => {
            this.error = true
            setTimeout(() => {
                this.error = false
            }, 5000)
        }
        )
    }
    onSwitchChange(event) {
        this.newForm.repeat = event.checked
        if (!this.newForm.repeat) {
            this.newForm.repeat_time = null
            this.newForm.from = null
            this.newForm.to = null
            this.newForm.date = new Date(this.selectedDate)
        }
        else {
            this.newForm.repeat_time = 0
            this.newForm.from = new Date(this.selectedDate)
            this.newForm.date = null
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/scheduling/scheduling-form/scheduling-form.component.ts